import { getSSRMode } from '@storefront/lib/getSSRMode';
const saveLocaleIntoCookie = (locale: string) => {
  document.cookie = `NEXT_LOCALE=${locale}; path=/`;
};
export const lookup = () => {
  if (getSSRMode()) return 'en_US';
  const { locale = 'us-en' } =
    /^\/(?<locale>[a-z]{2}-[a-z]{2})/.exec(window.location.pathname)?.groups ||
    {};
  const [country, language] = locale.split('-');
  const underscoreLocale = `${language}_${country.toUpperCase()}`;
  saveLocaleIntoCookie(underscoreLocale);
  return underscoreLocale;
};
export const urlDetector = {
  name: 'url',
  lookup,
};
